import {
  Box,
  Button,
  IconButton,
  Link,
  List,
  ListItem,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { DeleteOutline } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import type { PerformerList } from 'api-client/models';

interface Props {
  performers: PerformerList[];
  onDelete: (id: string) => void;
}

/** A compact, accessible list of the current server result page. */
export function SharedPerformerList({ performers, onDelete }: Props) {
  return (
    <Paper variant="outlined">
      <List disablePadding aria-label="Shared performers">
        {performers.map((performer, index) => (
          <ListItem
            key={performer.id}
            divider={index < performers.length - 1}
            sx={{ gap: 2, py: 1.5, alignItems: 'flex-start' }}
          >
            <Box sx={{ flex: 1, minWidth: 0, overflowWrap: 'anywhere' }}>
              <Link
                component={RouterLink}
                to={`/performers/${performer.id}`}
                fontWeight={600}
              >
                {performer.performerName}
              </Link>
              <Typography variant="body2" color="text.secondary">
                {[
                  performer.primaryCategory,
                  ...(performer.tags ?? []).slice(0, 3),
                ]
                  .filter(Boolean)
                  .join(' · ')}
              </Typography>
            </Box>
            <Stack direction="row" spacing={0.5} sx={{ flexShrink: 0 }}>
              <Button
                component={RouterLink}
                to={`/performers/${performer.id}/edit`}
                size="small"
                aria-label={`Edit ${performer.performerName}`}
              >
                Edit
              </Button>
              <IconButton
                size="small"
                color="error"
                aria-label={`Delete ${performer.performerName}`}
                onClick={() => onDelete(performer.id)}
              >
                <DeleteOutline fontSize="small" />
              </IconButton>
            </Stack>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
}
